import { useState, useEffect } from "react";
import DrawerTemplate from "../../hoc/drawerTemplate";
import { Requests_Fin } from "./Requests_Fin";
import Records_Fin from "./Records_Fin";
import FinanceReqRecAnalytics from "./FinanceReqRecAnalytics";
import DailyAnalytics from "./DailyAnalytics"; // New import
import "./Req_Rec_Card.scss";

const FinanceRec_Req = () => {
  const [activeTab, setActiveTab] = useState("Requests");
  const [isLoading, setIsLoading] = useState(false);

  const handleTabChange = (tab) => {
    setIsLoading(true);
    setTimeout(() => {
      setActiveTab(tab);
      setIsLoading(false);
    }, 100);
  };

  const formattedDate = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  });

  const tabs = [
    { key: "Requests", label: "Requests" },
    { key: "Records", label: "Records" },
    { key: "Analytics", label: "Analytics" },
    { key: "Updates", label: "Finance Updates" } // New tab
  ];

  return (
    <div
      className="finance-req-rec-container"
      style={{
        width: "100%",
        height: "100%",
        overflow: "auto",
        backgroundColor: "#f9fafb",
        boxSizing: "border-box"
      }}
    >
      <div
        className="finance-header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "15px 24px",
          borderBottom: "1px solid #eaecf0"
        }}
      >
        <h2
          style={{
            margin: 0,
            color: "#333",
            fontSize: "22px",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            gap: "10px"
          }}
        >
          <span
            style={{
              display: "inline-block",
              width: "4px",
              height: "22px",
              backgroundColor: "#fdd34d",
              borderRadius: "2px"
            }}
          ></span>
          Finance Requests & Records
        </h2>

        <div
          style={{
            padding: "6px 12px",
            backgroundColor: "#fffdf5",
            borderRadius: "6px",
            fontSize: "13px",
            color: "#555",
            fontWeight: "500",
            border: "1px solid #fdd34d"
          }}
        >
          {formattedDate}
        </div>
      </div>

      {/* Tabs */}
      <div
        className="tab-navigation"
        style={{
          display: "flex",
          borderBottom: "2px solid #eaecf0",
          // marginBottom: "20px",
          backgroundColor: "#ffffff",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
        }}
      >
        {tabs.map(({ key, label }) => (
          <div
            key={key}
            className={`tab-item ${activeTab === key ? "active" : ""}`}
            onClick={() => handleTabChange(key)}
            style={{
              flex: 1,
              textAlign: "center",
              padding: "18px 0",
              fontWeight: activeTab === key ? "600" : "400",
              color: activeTab === key ? "#333" : "#777",
              cursor: "pointer",
              borderBottom:
                activeTab === key ? "3px solid #fdd34d" : "none",
              backgroundColor:
                activeTab === key ? "#fffdf5" : "transparent",
              fontSize: "16px",
              transition: "all 0.2s"
            }}
          >
            {label}
          </div>
        ))}
      </div>

      {/* Tab Content */}
      <div
        className="tab-content"
        style={{
          padding: "20px 24px",
          width: "100%",
          boxSizing: "border-box"
        }}
      >
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "20px",
              color: "#888"
            }}
          >
            Loading...
          </div>
        ) : activeTab === "Requests" ? (
          <Requests_Fin />
        ) : activeTab === "Records" ? (
          <Records_Fin />
        ) : activeTab === "Analytics" ? (
          <FinanceReqRecAnalytics />
        ) : (
          <DailyAnalytics /> // Render DailyAnalytics for "Updates"
        )}
      </div>
    </div>
  );
};

export default DrawerTemplate(FinanceRec_Req);
